import React, { useEffect, useState } from 'react';
import LinkButton from '../button/LinkButton';
import ItemList from '../list/ItemList'; // Import the reusable list component
import { fetchAllAgents } from "../../api/AgentApi";
import { Agent, AgentStatus } from "../model";

const Agents: React.FC = () => {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadAgents = async () => {
      try {
        const data = await fetchAllAgents();
        setAgents(data);
      } catch (err) {
        setError('Failed to load agents');
      } finally {
        setLoading(false);
      }
    };

    loadAgents();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <div className="header-container">
        <LinkButton label="Create Agent" link="/agent" />
      </div>
      <ItemList
        items={agents}
        linkPrefix="agent"
        renderName={(agent) => agent.name}
        renderStatus={(agent) => agent.status!}
      />
    </>
  );
};

export default Agents;
